import React from "react"

export const Thanks = () => {
   return (
      <>
         <h1 className="bg-secondary text-white text-center">Thanks for getting with us!</h1>
      </>
   )
};